import dayjs from 'dayjs';
import { ReactNode } from 'react';
import { useParams } from 'react-router-dom';
import { useAppSelector } from 'store/hooks';
import { useFlags } from 'launchdarkly-react-client-sdk';

import Avatar from '../components/avatar';
import Footer, {
  ExpandHistoryButton,
  FooterActions,
  History,
  Item,
  Description,
  PersonInfo
} from '../components/footer/footer';

type Props = {
  children: ReactNode;
};

const ImpactFooter = ({ children }: Props) => {
  const { clientId = '' } = useParams();
  const { enableDateTimeUpdates } = useFlags();
  const impactScreenerHistory = useAppSelector(
    (state) => state.screener[clientId]?.screenerHistory?.impact
  );

  return (
    <Footer>
      <FooterActions>
        {impactScreenerHistory && impactScreenerHistory?.length > 0 ? (
          <ExpandHistoryButton />
        ) : (
          <button style={{ visibility: 'hidden' }}></button>
        )}
        {children}
      </FooterActions>
      <History>
        {impactScreenerHistory?.map((historyItem) => (
          <Item key={historyItem.id}>
            <Description>
              {enableDateTimeUpdates ? (
                <>
                  Screened on:{' '}
                  <span>
                    {dayjs(historyItem.dateAndTimeOfScreening ?? historyItem.submittedOn).format(
                      'M/D/YYYY h:mm a'
                    )}
                  </span>
                </>
              ) : (
                <>
                  Submitted on: <span>{dayjs(historyItem.submittedOn).format('M/D/YYYY')}</span>
                </>
              )}
            </Description>
            <PersonInfo>
              <Avatar imageUrl={historyItem.author.profileImageKey} />
              <p>{historyItem.author.name}</p>
            </PersonInfo>
          </Item>
        ))}
      </History>
    </Footer>
  );
};

export default ImpactFooter;
